'use client';

import Script from 'next/script';

/**
 * Loads and initializes Amplitude Analytics in the browser using Next.js Script tags.
 *
 * This component:
 * - Injects the Amplitude Browser SDK and Session Replay plugin after the page becomes interactive.
 * - Registers the Session Replay plugin with a 100% sampling rate (`sampleRate: 1`), so all sessions
 *   are eligible for replay capture.
 * - Enables Amplitude autocapture for element interactions (`autocapture.elementInteractions: true`),
 *   so clicks and other basic UI events are captured automatically.
 *
 * Include this component once at the top level of the application (e.g., in the root layout)
 * to ensure analytics and replay are initialized globally.
 */
export const AmplitudeScript = () => {
  return (
    <>
      <Script
        src="https://cdn.amplitude.com/script/3047587b01b1232e23931a810f3a5279.js"
        strategy="afterInteractive"
      />
      <Script
        id="amplitude-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html:
            `window.amplitude.add(window.sessionReplay.plugin({sampleRate: 1}));window.amplitude.init('3047587b01b1232e23931a810f3a5279', {"autocapture":{"elementInteractions":true}});`,
        }}
      />
    </>
  );
};

